import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function GenericErrorPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Box textAlign="center">
                <Typography variant="h4" component="h1" color="error" gutterBottom>
                    {t('common.error')}
                </Typography>
                <Typography variant="h6" color="text.secondary" paragraph>
                    {t('common.pageNotFoundOrError')}
                </Typography>
                <Button variant="contained" onClick={() => navigate('/')}>
                    {t('common.goToDashboard')}
                </Button>
            </Box>
        </Container>
    );
}

export default GenericErrorPage;